(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const decor = document.querySelector('[data-brutal-decor]');
  const thumb = document.querySelector('[data-thumbup-badge]');
  const stars = decor ? Array.from(decor.querySelectorAll('.brutal-decor__star')) : [];

  stars.forEach((star, index) => {
    star.dataset.phase = String(index * 0.85);
    star.dataset.dir = index % 2 === 0 ? '1' : '-1';
  });

  const syncDecorHeight = () => {
    if (!decor) return;
    decor.style.height = `${document.documentElement.scrollHeight}px`;
  };

  const update = () => {
    const y = window.scrollY || 0;
    const max = Math.max(1, document.documentElement.scrollHeight - window.innerHeight);
    const progress = Math.min(1, Math.max(0, y / max));

    if (thumb) {
      const entered = y > 24;
      thumb.classList.toggle('is-in', entered);
      if (!reduceMotion) {
        const rot = Math.sin(progress * Math.PI * 2.2) * 14 + progress * 18;
        thumb.style.setProperty('--thumb-rot', `${rot.toFixed(2)}deg`);
      }
    }

    if (!reduceMotion) {
      stars.forEach((star) => {
        const factor = Number(star.dataset.parallax || 0.12);
        const phase = Number(star.dataset.phase || 0);
        const dir = Number(star.dataset.dir || 1);
        const shiftY = y * factor * 0.55;
        const shiftX = Math.sin(progress * Math.PI * 1.4 + phase) * (10 + factor * 40) * dir;
        const rot =
          Math.sin(progress * Math.PI * 2.6 + phase) * (10 + factor * 28) * dir +
          progress * 12 * dir;

        star.style.setProperty('--parallax-x', `${shiftX.toFixed(1)}px`);
        star.style.setProperty('--parallax-y', `${shiftY.toFixed(1)}px`);
        star.style.setProperty('--parallax-r', `${rot.toFixed(2)}deg`);
      });
    }
  };

  let ticking = false;
  const onScroll = () => {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(() => {
      update();
      ticking = false;
    });
  };

  syncDecorHeight();
  update();
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', () => {
    syncDecorHeight();
    update();
  });

  if (typeof ResizeObserver !== 'undefined') {
    const ro = new ResizeObserver(() => syncDecorHeight());
    ro.observe(document.body);
  }
})();
